module.exports = __webpack_public_path__ + "img/icon-btn-ios1.191a8e61.png";